import { baseAIURL } from './baseAIURL';

export function getJobStatusUrl(requestId: string) {
  const url = baseAIURL();
  url.pathname += `jobs/${requestId}`;
  return url;
}
